import {
  Debounce,
  GlobalEvents,
  SectionRenderer,
  SnippetElement,
  defineElement,
  liquidValue,
  param
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __commonJS,
  __decorateClass,
  __toESM
} from "./chunk-XDKWOSVF.js";

// node_modules/topbar/topbar.min.js
var require_topbar_min = __commonJS({
  "node_modules/topbar/topbar.min.js"(exports, module) {
    (function(window2, document2) {
      "use strict";
      function repaint() {
        canvas.width = window2.innerWidth, canvas.height = 5 * options.barThickness;
        var ctx = canvas.getContext("2d");
        ctx.shadowBlur = options.shadowBlur, ctx.shadowColor = options.shadowColor;
        var stop, lineGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        for (stop in options.barColors)
          lineGradient.addColorStop(stop, options.barColors[stop]);
        ctx.lineWidth = options.barThickness, ctx.beginPath(), ctx.moveTo(0, options.barThickness / 2), ctx.lineTo(Math.ceil(currentProgress * canvas.width), options.barThickness / 2), ctx.strokeStyle = lineGradient, ctx.stroke();
      }
      var canvas, currentProgress, showing, progressTimerId = null, fadeTimerId = null, delayTimerId = null, options = { autoRun: true, barThickness: 3, barColors: { 0: "rgba(26,  188, 156, .9)", ".25": "rgba(52,  152, 219, .9)", ".50": "rgba(241, 196, 15,  .9)", ".75": "rgba(230, 126, 34,  .9)", "1.0": "rgba(211, 84,  0,   .9)" }, shadowBlur: 10, shadowColor: "rgba(0,   0,   0,   .6)", className: null }, topbar2 = { config: function(opts) {
        for (var key in opts)
          options.hasOwnProperty(key) && (options[key] = opts[key]);
      }, show: function(handler) {
        var type, elem;
        showing || (handler ? delayTimerId = delayTimerId || setTimeout(() => topbar2.show(), handler) : (showing = true, null !== fadeTimerId && window2.cancelAnimationFrame(fadeTimerId), canvas || ((elem = (canvas = document2.createElement("canvas")).style).position = "fixed", elem.top = elem.left = elem.right = elem.margin = elem.padding = 0, elem.zIndex = 100001, elem.display = "none", options.className && canvas.classList.add(options.className), document2.body.appendChild(canvas), type = "resize", handler = repaint, (elem = window2).addEventListener ? elem.addEventListener(type, handler, false) : elem.attachEvent ? elem.attachEvent("on" + type, handler) : elem["on" + type] = handler), canvas.style.opacity = 1, canvas.style.display = "block", topbar2.progress(0), options.autoRun && function loop() {
          progressTimerId = window2.requestAnimationFrame(loop), topbar2.progress("+" + 0.05 * Math.pow(1 - Math.sqrt(currentProgress), 2));
        }()));
      }, progress: function(to) {
        return void 0 === to || ("string" == typeof to && (to = (0 <= to.indexOf("+") || 0 <= to.indexOf("-") ? currentProgress : 0) + parseFloat(to)), currentProgress = 1 < to ? 1 : to, repaint()), currentProgress;
      }, hide: function() {
        clearTimeout(delayTimerId), delayTimerId = null, showing && (showing = false, null != progressTimerId && (window2.cancelAnimationFrame(progressTimerId), progressTimerId = null), function loop() {
          return 1 <= topbar2.progress("+.1") && (canvas.style.opacity -= 0.05, canvas.style.opacity <= 0.05) ? (canvas.style.display = "none", void (fadeTimerId = null)) : void (fadeTimerId = window2.requestAnimationFrame(loop));
        }());
      } };
      "object" == typeof module && "object" == typeof module.exports ? module.exports = topbar2 : "function" == typeof define && define.amd ? define(function() {
        return topbar2;
      }) : this.topbar = topbar2;
    }).call(exports, window, document);
  }
});

// src/shared/util.ts
var import_topbar = __toESM(require_topbar_min());
import_topbar.default.config({
  autoRun: true,
  barThickness: 2,
  barColors: {
    0: "#FDC546",
    "1.0": "#FDC546"
  },
  shadowBlur: 5,
  shadowColor: "rgba(0, 0, 0, .5)",
  className: "topbar"
});
var loading = false;
var startLoading = () => {
  if (loading)
    return;
  loading = true;
  import_topbar.default.show();
};
var stopLoading = () => {
  import_topbar.default.hide();
  loading = false;
};

// src/snippets/util-dyn-render/util-dyn-render.ts
var UtilDynRender = class extends SnippetElement {
  connectedCallback() {
    var _a, _b, _c;
    const events = (_b = (_a = this.events) == null ? void 0 : _a.split(",")) != null ? _b : [];
    const debouncedRender = Debounce.debounce(() => {
      this.render();
    }, (_c = this.time) != null ? _c : 1e3);
    events.forEach((e) => {
      if (this.debounce) {
        GlobalEvents.on(e, () => {
          debouncedRender();
        });
      } else {
        GlobalEvents.on(e, () => __async(this, null, function* () {
          yield this.render();
        }));
      }
    });
  }
  render() {
    return __async(this, null, function* () {
      var _a;
      const delayedLoading = setTimeout(() => {
        startLoading();
      }, 120);
      const html = yield SectionRenderer.renderSection(this.sectionId);
      const dynHtml = (_a = new DOMParser().parseFromString(html, "text/html").querySelector(`[dyn-render-key="${this.key}"]`)) == null ? void 0 : _a.innerHTML;
      if (dynHtml != null)
        this.innerHTML = dynHtml;
      clearTimeout(delayedLoading);
      stopLoading();
    });
  }
};
__decorateClass([
  liquidValue("section.id")
], UtilDynRender.prototype, "sectionId", 2);
__decorateClass([
  param()
], UtilDynRender.prototype, "key", 2);
__decorateClass([
  param()
], UtilDynRender.prototype, "events", 2);
__decorateClass([
  param()
], UtilDynRender.prototype, "debounce", 2);
__decorateClass([
  param()
], UtilDynRender.prototype, "time", 2);
UtilDynRender = __decorateClass([
  defineElement("util-dyn-render")
], UtilDynRender);
export {
  UtilDynRender
};
/*! Bundled license information:

topbar/topbar.min.js:
  (**
   * @license MIT
   * topbar 2.0.0, 2023-02-04
   * http://buunguyen.github.io/topbar
   * Copyright (c) 2021 Buu Nguyen
   *)
*/
